var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1411_6527",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(180 24 24)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1411_6527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.70919 15.0711C2.93408 15.1453 3.08401 15.1453 3.23394 15.1453C3.15898 15.1453 3.30891 15.1453 3.23394 15.1453H8.78137V19.2955C8.78137 20.2589 9.53102 21 10.5056 21H12.7545C13.0544 21 13.2043 20.9259 13.4292 20.8518C13.7291 20.7777 13.954 20.5553 14.1789 20.333L18.0771 15.3676H20.7758C21.7503 15.2935 22.5 14.5524 22.5 13.5889V3.95455C22.5 2.99111 21.7503 2.25 20.7758 2.25H6.30752C5.93269 2.25 5.55786 2.39822 5.258 2.62055C4.95814 2.84289 4.80821 3.13933 4.73325 3.43577L1.58471 12.9219C1.28485 13.8854 1.8096 14.8488 2.70919 15.0711ZM19.4264 5.58498V11.9585H18.0771V5.58498H19.4264ZM14.9285 5.58498V13.7372L12.1548 17.2945V13.4407C12.1548 12.4773 11.4051 11.7362 10.4306 11.7362H5.55786L7.58192 5.58498H14.9285Z",
    fill: "#C63838"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/thumb-down.38317587b5e0877209b1d38b59bf7b4c.svg";
export { ForwardRef as ReactComponent };